
import Content from '../knowledge-points/Content.vue'
export default {
  components: {
    Content
  }
}
